var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")}}),_vm._v(" "),_c('div',{staticClass:"unsub-text",staticStyle:{"text-align":"center","color":"black"}},[_vm._v("  "+_vm._s(_vm.msg))]),_vm._v(" "),_c('div',{staticClass:"btn btn-blue btn-block",on:{"click":_vm.goto}},[_vm._v("စာရင်းသွင်းခြင်း။")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d4e2944","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error.vue
// module id = null
// module chunks = 